import { Box, Typography, Divider } from "@mui/material";

export default function BankTransfer() {
  const rows = [
    { label: "Account Name", value: "LONDONIST DMC LTD" },
    { label: "Bank Name", value: "BARCLAYS BANK" },
    { label: "Branch Name", value: "PICCADILLY CIRCUS" },
    { label: "Bank Address", value: "48 REGENT STREET, LONDON W1B 5RA" },
    { label: "Sort Code", value: "20-71-75" },
    { label: "Account no", value: "03673456" },
  ];

  const intlRows = [
    { label: "BIC/Swift Code", value: "BUKBGB22" },
    { label: "IBAN No", value: "GB93 BUKB 2071 7503 6734 56" },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

      <Box
        sx={{
          borderRadius: ".75rem",
          border: "1px solid #e6e6e6",
          backgroundColor: "#fff",
          overflow: "hidden",
        }}
      >
        <Box sx={{ padding: "1rem 1.25rem" }}>
          {rows.map((row, idx) => (
            <Box key={row.label} sx={{ display: "flex", gap: 2, py: .5 }}>
              <Typography sx={{ width: 180, color: "#777", fontWeight: 500 }}>
                {row.label} :
              </Typography>
              <Typography sx={{ fontWeight: 600 }}>{row.value}</Typography>
            </Box>
          ))}
        </Box>
        <Divider />
        <Box sx={{ padding: "1rem 1.25rem" }}>
          <Typography sx={{ fontSize: "16px", fontWeight: 600, mb: 1 }}>
            If you are making an international transfer, please quote:
          </Typography>
          {intlRows.map((row) => (
            <Box key={row.label} sx={{ display: "flex", gap: 2, py: .5 }}>
              <Typography sx={{ width: 180, color: "#777", fontWeight: 500 }}>
                {row.label} :
              </Typography>
              <Typography sx={{ fontWeight: 600 }}>{row.value}</Typography>
            </Box>
          ))}
        </Box>
      </Box>

      <Typography sx={{ fontSize: "16px", color: "#555" }}>
        How to Make Payment through Bank Transfer: You can pay securely by transferring the total amount through your online banking app, mobile banking, or by visiting your local bank branch.
      </Typography>
    </Box>
  );
}


